<template>
    <div>
       <div v-bind:style="dynamicStyle">
          <div v-if="show_screenshot && example_screenshot && example_screenshot.public_url">
            <a :href="example_screenshot.request_url">
               <img  width="100%" style="border: 1px solid black" :src="example_screenshot.public_url" />
            </a>
          </div>
            {{commarize(display_value)}}<span v-if="type=='percentage'">%</span>
        </div>
    </div>
</template>

<script>
    const tinycolor = require('tinycolor2')
    export default {
        name: "TableHeatmapCell",
        props: ['value','display_value','min','max','heatmappable','type', 'max_background_color', 'example_screenshot', 'show_screenshot'],
        computed: {
            dynamicStyle: function () {
                let background = tinycolor('darkgray')
                if (this.max_background_color) {
                    background = tinycolor(this.max_background_color)
                }
                let foreground = tinycolor('black')
                if (this.heatmappable) {
                    if (this.value===0) {
                      foreground = tinycolor('pink')
                      foreground = foreground.setAlpha(0.5)
                      background = background.setAlpha(0)
                    } else {
                      let background_percent = (this.value - this.min) / (this.max - this.min)
                      background = background.setAlpha(background_percent)
                    }
                }
                background = background.toString()
                foreground = foreground.toString()
                return {
                    'background-color': background,
                    color: foreground,
                    padding: '1px',
                    margin: '0px'
                }
            }
        },
        methods: {
            commarize(number) {
                let min = 1e3;
                // Alter numbers larger than 1k
                if (number >= min) {
                    var units = ["k", "M", "B", "T", "Q"];

                    var order = Math.floor(Math.log(number) / Math.log(1000));

                    var unitname = units[(order - 1)];
                    var num = Math.floor(number / 1000 ** order);

                    // output number remainder + unitname
                    return num + unitname
                }

                // return formatted original number
                return number.toLocaleString()
            },
        }
    }
</script>

<style scoped>

</style>